import { Injectable } from '@angular/core';
import {
  SearchAction,
  SearchableItem,
  SearchDataLoaderService,
  SearchProvider,
} from '@core/search';
import { PlatformService } from 'src/app/core/services/platform/platform.service';
import {
  SettingsPayload,
  buildSettingsIndex,
} from './settings-search-index.builder';

/**
 * Settings-domain search provider. Loads richer keyword lists from
 * `data/settings-keywords.<lang>.json` lazily and merges them with the
 * existing index entries from SearchIndexBuilder.
 *
 * iOS hides subscription items (App Store guideline 3.1.1).
 */
@Injectable({ providedIn: 'root' })
export class SettingsSearchProvider implements SearchProvider<SettingsPayload> {
  readonly id = 'settings';
  readonly displayNameKey = 'SETTINGS.NAV_TITLE';

  private isIos: boolean;

  constructor(
    private loader: SearchDataLoaderService,
    private platform: PlatformService
  ) {
    this.isIos = this.platform.isIos();
  }

  async getItems(lang: string): Promise<SearchableItem<SettingsPayload>[]> {
    const keywords = await this.loader.loadProviderData<Record<string, string[]>>(
      `settings-keywords.${lang}`,
      lang === 'de'
        ? () => import('./data/settings-keywords.de.json').then((m) => m.default)
        : () => import('./data/settings-keywords.en.json').then((m) => m.default)
    );
    let items = buildSettingsIndex(keywords);
    if (this.isIos) {
      items = items.filter((it) => it.payload.category !== 'subscription');
    }
    return items;
  }

  getActionFor(item: SearchableItem<SettingsPayload>): SearchAction {
    return {
      type: 'navigate',
      route: item.payload.route,
      section: item.payload.section,
    };
  }
}
